import React, { useState } from 'react';
import useTsrEnquirySubmit from '../hooks/useTsrEnquirySubmit';

/**
 * Shared enquiry form (Name, Phone, Message) used across TSR pages.
 */
function EnquiryForm({ widgetElementId = '13134c9', buttonLabel = 'Enquire' }) {
	const [form, setForm] = useState({ name: '', phone: '', message: '' });
	const { submitting, message, clearMessage, handleSubmit: submitEnquiry } = useTsrEnquirySubmit();

	const wrapId = `metform-wrap-${widgetElementId}-763`;

	const handleChange = (field) => (e) => {
		setForm((prev) => ({ ...prev, [field]: e.target.value }));
		clearMessage();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const ok = await submitEnquiry({
			formType: 'Enquiry',
			name: form.name.trim(),
			phone: form.phone.trim(),
			message: form.message.trim(),
		});
		if (ok) {
			setForm({ name: '', phone: '', message: '' });
		}
	};

	const feedbackClass = [
		'tsr-enquiry-feedback',
		message.type === 'success' ? 'tsr-enquiry-feedback--success' : '',
		message.type === 'error' ? 'tsr-enquiry-feedback--error' : '',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div
			className={`elementor-element elementor-element-${widgetElementId} elementor-widget elementor-widget-metform tsr-enquiry-form`}
			data-id={widgetElementId}
			data-element_type="widget"
			data-e-type="widget"
			data-widget_type="metform.default"
		>
			<div className="elementor-widget-container">
				<div id="mf-response-props-id-763" className="mf-scroll-top-no">
					<div className="formpicker_warper formpicker_warper_editable">
						<div className="mf-widget-container">
							<div id={wrapId} className="mf-form-wrapper">
								<form className="metform-form-content" onSubmit={handleSubmit} noValidate>
									{message.text ? (
										<div role="alert" aria-live="polite" className={feedbackClass}>
											{message.text}
										</div>
									) : null}
									<div className="metform-form-main-wrapper">
										<div data-elementor-type="wp-post" data-elementor-id="763" className="elementor elementor-763">
											<section className="elementor-section elementor-top-section elementor-element elementor-element-26ea9738 elementor-section-full_width elementor-section-height-default" data-id="26ea9738" data-element_type="section">
												<div className="elementor-container elementor-column-gap-default">
													<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7c8f3e4b" data-id="7c8f3e4b" data-element_type="column">
														<div className="elementor-widget-wrap elementor-element-populated">
															<section className="elementor-section elementor-inner-section elementor-element elementor-element-6a37e2f9 elementor-section-full_width elementor-section-height-default" data-id="6a37e2f9" data-element_type="section">
																<div className="elementor-container elementor-column-gap-default">
																	<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-24dd7809" data-id="24dd7809" data-element_type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-184663a1 elementor-widget elementor-widget-mf-text" data-id="184663a1" data-element_type="widget">
																				<div className="elementor-widget-container">
																					<div className="mf-input-wrapper">
																						<label className="mf-input-label" htmlFor={`mf-name-${widgetElementId}`}>
																							Name <span className="mf-input-required-indicator">*</span>
																						</label>
																						<input
																							type="text"
																							className="mf-input"
																							id={`mf-name-${widgetElementId}`}
																							name="mf-first-name"
																							placeholder=""
																							required
																							value={form.name}
																							onChange={handleChange('name')}
																						/>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-1e243baf" data-id="1e243baf" data-element_type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-185504a elementor-widget elementor-widget-mf-telephone" data-id="185504a" data-element_type="widget">
																				<div className="elementor-widget-container">
																					<div className="mf-input-wrapper">
																						<label className="mf-input-label" htmlFor={`mf-phone-${widgetElementId}`}>
																							Phone no. <span className="mf-input-required-indicator">*</span>
																						</label>
																						<input
																							type="tel"
																							className="mf-input"
																							id={`mf-phone-${widgetElementId}`}
																							name="mf-telephone"
																							placeholder=""
																							required
																							value={form.phone}
																							onChange={handleChange('phone')}
																						/>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</section>
															<section className="elementor-section elementor-inner-section elementor-element elementor-element-1f6daab4 elementor-section-full_width elementor-section-height-default" data-id="1f6daab4" data-element_type="section">
																<div className="elementor-container elementor-column-gap-default">
																	<div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-54f54cbc" data-id="54f54cbc" data-element_type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-7e5c045e elementor-widget elementor-widget-mf-textarea" data-id="7e5c045e" data-element_type="widget">
																				<div className="elementor-widget-container">
																					<div className="mf-input-wrapper">
																						<label className="mf-input-label" htmlFor={`mf-message-${widgetElementId}`}>Message</label>
																						<textarea
																							className="mf-input mf-textarea"
																							id={`mf-message-${widgetElementId}`}
																							name="mf-comment"
																							placeholder=""
																							cols="30"
																							rows="10"
																							value={form.message}
																							onChange={handleChange('message')}
																						></textarea>
																					</div>
																				</div>
																			</div>
																			<div className="elementor-element elementor-element-d3af341 mf-btn--left elementor-widget__width-auto elementor-widget elementor-widget-mf-button" data-id="d3af341" data-element_type="widget">
																				<div className="elementor-widget-container">
																					<div className="mf-btn-wraper">
																						<button type="submit" className="metform-btn metform-submit-btn" disabled={submitting}>
																							<span>{submitting ? 'Sending...' : buttonLabel}</span>
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</section>
														</div>
													</div>
												</div>
											</section>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EnquiryForm;
